"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItem = getItem;
exports.removeItem = removeItem;
exports.setItem = setItem;

/* eslint-disable no-empty */
function setItem(key, item) {
  try {
    localStorage.setItem(key, item);
  } catch (e) {}
}

function getItem(key) {
  var retVal;

  try {
    retVal = localStorage.getItem(key);
  } catch (_e) {
    retVal = null;
  }

  return retVal;
}

function removeItem(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {}
}